import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ClusterNode,
  NgxGraphZoomOptions,
  GraphModule,
} from '@swimlane/ngx-graph';
import * as shape from 'd3-shape';
import { Subject, firstValueFrom } from 'rxjs';
import {
  ConditionalLogic,
  FormConditionalLogic,
  NavigationData,
  SectionConditions,
} from '../../Models/ConditionalLogic-data.model';
import { Edge, Node } from '../../Models/node.model';
import { ApiServiceService } from '../../services/api-service.service';
import Utils from '../../shared/utils';
import swal from 'sweetalert2';
import { v4 as uuid } from 'uuid';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgClass, SlicePipe } from '@angular/common';
import { ISectionInfo } from '../../buyer-preview/multi-section-form-preview/multi-section-form-preview.models';

@Component({
  selector: 'questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css'],
  standalone: true,
  imports: [
    NgClass,
    GraphModule,
    FormsModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule,
    SlicePipe,
  ],
})
export class QuestionsComponent implements OnInit {
  @ViewChild('configureMdl') configureMdl: any;
  @ViewChild('infoModal') infoModal: any;
  @ViewChild('confirmationModal') confirmationModal: any;
  @ViewChild('addLinkModal') addLinkModal: any;
  @ViewChild('sectionDetails') sectionDetails: any;

  questions: any = [];
  dropdownQuestions: any = [];

  selectedQuestions: any = [];
  selectedIndex: any;
  isStarted = false;
  modalReference: any;
  modalConfirmReference: any;
  modalAddLinkReference: any;

  configureForm = new FormGroup({
    isAllowScoring: new FormControl(false),
    mandatory: new FormControl(false),
    Label: new FormControl(''),
    conditions: new FormControl(false),
    navigateTo: new FormControl(''),
    selection: new FormControl(null),
  });
  messageData: any = '';
  optionsData: any = [];
  selectedNode: any;
  
  extractedQuestion: string = '';
  extractedConditionalLogic: string = '';
  @ViewChild('JSONImportContent') JSONImportContent: any;
  uploadedFile: File[] | null = null;
  modalQuestionImportResponse: any;
  importForm = new FormGroup({});

  nodes: Node[] = [
    {
      id: '1',
      label: 'START',
      mandatory: '',
      condition: '',
      scoring: '',
    },
  ];
  clusters: ClusterNode[] = [];
  links: Edge[] = [];
  layout = 'dagreCluster';

  // line interpolation
  curve: any = shape.curveLinear;

  draggingEnabled: boolean = false;
  panningEnabled: boolean = true;
  zoomEnabled: boolean = true;

  zoomSpeed: number = 0.1;
  minZoomLevel: number = 0.1;
  maxZoomLevel: number = 4.0;
  panOnZoom: boolean = true;

  autoZoom: boolean = false;
  autoCenter: boolean = false;

  update$: Subject<boolean> = new Subject();
  center$: Subject<boolean> = new Subject();
  zoomToFit$: Subject<NgxGraphZoomOptions> = new Subject();
  isGraphLoaded = true;
  nodeRelations: any = [];
  linkToRemove: any;

  conditionLogicObjs: any = [];
  AllQuestions: any = [];
  isSection = false;
  SectionFlow: FormGroup;
  res: any[] = [];
  constructor(
    private modalService: NgbModal,
    public apiService: ApiServiceService,
    private formBuilder: FormBuilder
  ) {
    if (!localStorage.getItem('ConditionalLogicData')) {
      this.manuallyDefineConditionalLogicData();
    }

    if (localStorage.getItem('AllQuestions')) {
      this.questions = JSON.parse(localStorage.getItem('AllQuestions') || '');
    }
    const sectionFlag = localStorage.getItem('isSection');
    this.isSection = JSON.parse(sectionFlag);
    if (this.isSection) {
      this.questions[0]?.Section?.forEach((currSec) => {
        if (currSec?.Sections?.length) {
          currSec?.Sections?.forEach((subSec) => {
            if (subSec?.Fields?.length) {
              this.res = [...this.res, ...subSec?.Fields];
            }
          });
        }
        if (currSec?.Fields?.length) {
          this.res = [...this.res, ...currSec?.Fields];
        }
      });
      this.AllQuestions = [...this.res];
    } else {
      this.AllQuestions = this.questions[0]?.Section?.filter(
        (item) => item.Title !== 'Submitter'
      )[0].Fields;
    }
    this.dropdownQuestions = [...this.questions];
    this.dropdownQuestions.map((ques: any) => (ques.isSelected = false));
  }

  dropdownSettings: any = {};
  form: FormGroup;

  curate(conditionalLogicData) {
    return conditionalLogicData?.SectionConditions?.filter(
      (sec) => sec.ConditionalLogic?.length
    )
      ?.map((sec) => sec.ConditionalLogic)
      ?.flat();
  }

  getCuratedLogicData() {
    let cldStored: FormConditionalLogic = new FormConditionalLogic();
    if (localStorage.getItem('ConditionalLogicData')) {
      cldStored = JSON.parse(
        localStorage.getItem('ConditionalLogicData') || ''
      );
    }
    const cld: FormConditionalLogic = { ...cldStored };
    const cldsc: SectionConditions[] = [...{ ...cldStored }.SectionConditions];
    cldsc.forEach((sc, idx) => {
      if (idx === 0) {
        sc['ConditionalLogic'] = this.curate(cldStored);
      } else {
        sc['ConditionalLogic'] = [];
      }
    });
    cld['SectionConditions'] = cldsc;
    return cld;
  }

  defineDummyConditionalLogicData() {
    const sections = JSON.parse(localStorage.getItem('AllQuestions'))[0]
      .Section;
    const conditionalLogicData = {
      TemplateID: localStorage.getItem('TemplateId') ?? '',
      ChartJson: null,
      SectionConditions: sections.map((secItem) => ({
        UniqueID: secItem.UniqueID,
        ConditionalLogic: [],
      })),
    };
    localStorage.setItem(
      'ConditionalLogicData',
      JSON.stringify(conditionalLogicData)
    );
  }

  manuallyDefineConditionalLogicData() {
    if (localStorage.getItem('ConditionalLogicData')) {
      this.defineDummyConditionalLogicData();
    }
    this.triggerGetConditionaDetails();
  }

  triggerGetConditionaDetails() {
    this.apiService.GetConditionaDetails().subscribe({
      next: (response: any) => {
        // Omit all the submitter sections from the Get Conditional response before locally storing
        if (!this.isSection) {
          const submitterSections =
            JSON.parse(localStorage.getItem('submitterSections')) ?? [];
          response.Data.SectionConditions =
            response.Data?.SectionConditions?.filter(
              (section) =>
                !submitterSections
                  ?.map((submitter) => submitter.UniqueID)
                  ?.includes(section.SectionUniqueID)
            );
        }
        localStorage.setItem(
          'ConditionalLogicData',
          JSON.stringify(response.Data)
        );
      },
      error: (error: any) => {
        if (window.location.origin.includes('localhost')) {
          this.defineDummyConditionalLogicData();
        }
      },
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({});

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'UniqueID',
      textField: 'Name',
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };

    let conditionalLogicData: any;
    if (localStorage.getItem('ConditionalLogicData')) {
      conditionalLogicData = JSON.parse(
        localStorage.getItem('ConditionalLogicData') || ''
      );
    }
    this.formMultiitionalLogic = conditionalLogicData;

    if (
      !this.isSection &&
      this.formMultiitionalLogic?.SectionConditions[0].ConditionalLogic.length
    ) {
      this.nodes = JSON.parse(this.formMultiitionalLogic.ChartJson)[0].Nodes;
      this.links = JSON.parse(this.formMultiitionalLogic.ChartJson)[0].Links;
      this.conditionalLogicData = conditionalLogicData.SectionConditions[0];
    }

    if (this.isSection) {
      if (!this.formMultiitionalLogic?.SectionConditions?.length) {
        const sections = JSON.parse(localStorage.getItem('AllQuestions'))[0]
          .Section;
        this.formMultiitionalLogic['SectionConditions'] = sections?.map(
          (secItem) => ({
            UniqueID: secItem.UniqueID,
            ConditionalLogic: [],
          })
        );
      }
      const sectionsWithLogic =
        this.formMultiitionalLogic?.SectionConditions?.filter(
          (s) => s?.ConditionalLogic?.length
        );
      const idxOfSecWithLogic =
        this.formMultiitionalLogic?.SectionConditions?.findIndex(
          (s) => s?.ConditionalLogic?.length
        );
      const secIdxWithLogic = idxOfSecWithLogic === -1 ? 0 : idxOfSecWithLogic;
      const parsedChartJson = this.formMultiitionalLogic?.ChartJson
        ? JSON.parse(this.formMultiitionalLogic?.ChartJson)
        : null;
      this.nodes = parsedChartJson?.[0]?.Nodes ?? [
        {
          id: '1',
          label: 'START',
          mandatory: '',
          condition: '',
          scoring: '',
        },
      ];
      this.links = parsedChartJson?.[0]?.Links ?? [];
      const curatedLogicData = this.getCuratedLogicData();
      this.conditionalLogicData =
        sectionsWithLogic?.length > 1
          ? curatedLogicData?.SectionConditions?.[0]
          : conditionalLogicData?.SectionConditions?.[secIdxWithLogic];

    }
  }

  clearSelectedQuestion() {
    this.configureForm.controls.selection.reset();
    this.configureForm.controls.navigateTo.reset();
  }

  getQuestionLabel(quesData: any) {
    let label;
    let quesTextFound = quesData.data.filter(
      (quesdata: any) => quesdata.type == 'text'
    );

    if (quesTextFound && quesTextFound.length > 0) {
      label = label =
        quesTextFound[0].value.length > 10
          ? quesTextFound[0].value.substring(0, 10) + '...'
          : quesTextFound[0].value;
    } else {
      label = quesData.displayquestion;
    }
    return label;
  }

  selectedQnIdx: number = 0;
  onQuesSelection(index: number) {
    this.selectedQnIdx = index;
  }

  onQuestionAdd() {
    this.selectedQuestions = [...this.questions];
  }

  onStartEvent() {
    this.isStarted = true;
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  onConfigureClick() {
    this.modalReference = this.modalService.open(this.configureMdl, {
      size: 'lg',
      scrollable: true,
    });
  }

  onSubmitConfigForm() {}

  closeModal() {
    this.modalReference.close();
    this.messageData = '';
  }

  getQuestionLable(quesData: any, index?: number) {
    let label;
    let quesTextFound = quesData.data.filter(
      (quesdata: any) => quesdata.type == 'text'
    );

    if (quesTextFound && quesTextFound.length > 0) {
      if (quesTextFound[0].dispalyFCText) {
        label =
          quesTextFound[0].dispalyFCText.length > 18
            ? quesTextFound[0].dispalyFCText.substring(0, 18) + '...'
            : quesTextFound[0].dispalyFCText;
      } else {
        label =
          quesTextFound[0].value.length > 18
            ? quesTextFound[0].value.substring(0, 18) + '...'
            : quesTextFound[0].value;
      }
    } else {
      label = quesData.displayquestion;
    }
    return label;
  }

  onRightClick(event: any) {
    event.preventDefault();
    this.isStarted = true;
    this.onConfigureClick();
  }

  onMandatoryCheck() {
    if (this.configureForm.controls['mandatory'].value) {
      let index = this.nodeRelations.findIndex(
        (data: any) => data.conditionID != null || undefined
      );
      if (index != -1) {
        this.removeLinkConfirmation(
          this.nodeRelations.find(
            (data: any) => data.conditionID == null || undefined
          ),
          false
        );
        this.configureForm.controls.conditions.disable();
        this.configureForm.controls['conditions'].setValue(true);
        if (!this.optionsData.length) {
          this.configureForm.controls.selection.disable();
          this.configureForm.controls.navigateTo.disable();
        }
      }
    } else {
      this.configureForm.controls.conditions.enable();
    }
  }

  onConditionChange() {
    this.configureForm.controls.navigateTo.enable();
    let index = this.nodeRelations.findIndex(
      (data: any) => data.conditionID == null || undefined
    );
    if (index != -1 && this.nodeRelations.length) {
      this.configureForm.controls.navigateTo.disable();
    }

    if (this.configureForm.value.conditions) {
      let selectedNodeData = this.findObjectByUniqueID(this.selectedNode.id);
      let UniqueValues = [];
      if (selectedNodeData) {
        this.optionsData = [];
        if (this.nodeRelations.length) {
          const idsInArrayTwo = new Set(
            this.nodeRelations.map((item) => item.conditionID)
          );
          UniqueValues = selectedNodeData.Options.filter(
            (item) => !idsInArrayTwo.has(item.UniqueID)
          );
        } else {
          UniqueValues = selectedNodeData.Options;
        }
        this.optionsData = UniqueValues;
        if (
          !this.optionsData.length &&
          this.configureForm.controls.conditions.value
        ) {
          this.configureForm.controls.selection.disable();
          this.configureForm.controls.navigateTo.disable();
        } else {
          this.configureForm.controls.selection.enable();
          this.configureForm.controls.navigateTo.enable();
        }
      } else {
        this.configureForm.controls.selection.disable();
        this.configureForm.controls.navigateTo.disable();
      }
    } else {
      let index = this.nodeRelations.findIndex(
        (data: any) => data.conditionID != null || undefined
      );
    }
  }

  identify(index: number, item: any): number {
    return item.id;
  }

  SourceQuestionId = '';
  SourecQuestionLabel = '';
  select(data: any) {
    this.form = this.formBuilder.group({});
    this.configureForm = new FormGroup({
      isAllowScoring: new FormControl(false),
      mandatory: new FormControl(false),
      Label: new FormControl(''),
      conditions: new FormControl(false),
      navigateTo: new FormControl(''),
      selection: new FormControl(null),
    });

    this.SourceQuestionId = '';
    this.SourecQuestionLabel = '';
    this.SourceQuestionId = data.id;
    let selectedQuestion = this.findObjectByUniqueID(this.SourceQuestionId);

    if (selectedQuestion) {
      if (
        selectedQuestion.Type == 'TextArea' ||
        selectedQuestion.Type == 'TextInput'
      ) {
        this.configureForm.controls.conditions.disable();
        this.configureForm.controls['conditions'].setValue(false);
      }
    }
    if (this.SourceQuestionId == '1') {
      this.configureForm.controls.mandatory.disable();
      this.configureForm.controls['mandatory'].setValue(false);
      this.configureForm.controls.conditions.disable();
      this.configureForm.controls['conditions'].setValue(false);
      this.configureForm.controls.isAllowScoring.disable();
      this.configureForm.controls['isAllowScoring'].setValue(false);
    }

    this.SourecQuestionLabel = data.label;
    this.selectedNode = data;

    let filterLinks = this.links.filter(
      (link: any) => link.source == this.SourceQuestionId
    );

    filterLinks.forEach((elemet, index) => {
      this.form.addControl(`selectedItems_${elemet.id}`, new FormControl([]));
      this.form.get(`selectedItems_${elemet.id}`).setValue(elemet.data);
    });
    let sourcQuestion = this.findConditionalUniqueID(this.SourceQuestionId);

    if (sourcQuestion != undefined) {
      this.configureForm
        .get('conditions')
        .setValue(sourcQuestion.ConditionsExist);
      this.configureForm
        .get('isAllowScoring')
        .setValue(sourcQuestion.AllowScoring);
      this.configureForm.get('mandatory').setValue(sourcQuestion.Mandatory);
    }

    this.assignNodeRelations();
    this.onConfigureClick();
    this.onConditionChange();
  }
  assignNodeRelations() {
    this.nodeRelations = [];
    this.nodeRelations = this.links.filter(
      (link: any) => link.source == this.selectedNode.id
    );
  }

  findObjectByUniqueID(uniqueIDToFind: any) {
    return this.AllQuestions.find(
      (item: { UniqueID: any }) => item.UniqueID === uniqueIDToFind
    );
  }

  findConditionalUniqueID(uniqueIDToFind: any) {
    return this.conditionalLogicData?.ConditionalLogic?.find(
      (item) => item?.SourceQuestinID === uniqueIDToFind
    );
  }
  pushItemByUniqueID(itemToAdd: any, uniqueID: string) {
    const index = this.conditionalLogicData.ConditionalLogic.findIndex(
      (item) => item.SourceQuestinID === uniqueID
    );
    if (index !== -1) {
      this.conditionalLogicData.ConditionalLogic.splice(index, 1, itemToAdd); 
    }
  }
  removeNavigationQuetion(SourecQuetionID: any, destinationQuestionID: any) {
    const j = this.navigationOptions.findIndex(
      (item: { DestinationQuestionID: any }) =>
        item.DestinationQuestionID === destinationQuestionID
    );
    if (j !== -1) {
      this.navigationOptions.splice(j, 1);
    }

    const index = this.conditionalLogicData.ConditionalLogic.findIndex(
      (item) => item.SourceQuestinID === SourecQuetionID
    );
    if (index !== -1) {
      const i = this.conditionalLogicData.ConditionalLogic[
        index
      ].Conditions.findIndex(
        (item) => item.DestinationQuestionID === destinationQuestionID
      );
      if (i !== -1) {
        this.conditionalLogicData.ConditionalLogic[index].Conditions.splice(
          i,
          1
        );
      }
    }
    const qindex = this.conditionalLogicData.ConditionalLogic.findIndex(
      (item) => item.SourceQuestinID === destinationQuestionID
    );
    if (qindex !== -1) {
      this.conditionalLogicData.ConditionalLogic.splice(qindex, 1);
    }
  }

  updateQuestionValues(SourceQuestinid: any, data: any) {
    const index = this.conditionalLogicData.ConditionalLogic.findIndex(
      (item) => item.SourceQuestinID === SourceQuestinid
    );
    if (index !== -1) {
      this.conditionalLogicData.ConditionalLogic[index].AllowScoring =
        data.isAllowScoring;
      this.conditionalLogicData.ConditionalLogic[index].ConditionsExist =
        data.conditions;
      this.conditionalLogicData.ConditionalLogic[index].Mandatory =
        data.mandatory; 
    }
  }

  conditionalLogicData = new SectionConditions();
  myObject: any = [];
  navigationData = new NavigationData();

  onOkMdl(isModalClose?: boolean) {
    if (this.isSection) {
      this.onClickOK(isModalClose);
    } else {
      this.onOkMdlSingleSection(isModalClose);
    }
  }
  onOkMdlSingleSection(isModalClose?: boolean) {
    let startNode = {
      SourceQuestinID: '1',
      ConditionsExist: false,
      Mandatory: false,
      Name: 'START',
      AllowScoring: false,
      DisplayOrder: 0,
      Conditions: [],
    };
    let label = '';
    let CreateObjectForDestinationNode = new ConditionalLogic();
    if (!this.findConditionalUniqueID('1')) {
      this.conditionalLogicData.ConditionalLogic.push(startNode);
    }
    if (isModalClose) {
      this.modalReference.close();
    }
    let navigationcontent = true;
    if (!this.configureForm.value.navigateTo) {
      navigationcontent = false;
    }
    if (!isModalClose && navigationcontent) {
      let selectedQuestion = this.findObjectByUniqueID(
        this.configureForm.value.navigateTo
      );
      label = selectedQuestion.Name;
      let sourcQuestion = this.findObjectByUniqueID(this.SourceQuestionId);
      let edgeValue = '';
      if (sourcQuestion && sourcQuestion.Options) {
        let options = sourcQuestion.Options.find(
          (item: { UniqueID: any }) =>
            item.UniqueID === this.configureForm.value.selection
        );
        if (options) {
          edgeValue = options.OptionValue;
        }
      }
      this.navigationData.UniqueID = uuid();
      this.navigationData.DestinationQuestionID =
        this.configureForm.value.navigateTo || '';
      this.navigationData.EdgeRefID = this.configureForm.value.selection || '';
      this.navigationData.EdgeValue = edgeValue || '';
      this.navigationData.MandatoryDependantQuestion = [];
      this.navigationData.Score = 0;
      this.navigationOptions.push(this.navigationData);
      CreateObjectForDestinationNode.SourceQuestinID = this.SourceQuestionId;

      this.navigationData = new NavigationData();

      if (selectedQuestion.Name) {
        this.configureForm.value.Label = selectedQuestion.Name;
      } else {
        this.configureForm.value.Label = selectedQuestion.Label;
      }

      this.isGraphLoaded = false;
      this.addToNodes(
        this.configureForm.value.Label,
        edgeValue,
        this.configureForm.value.selection,
        this.configureForm.value.navigateTo
      );
    }
    let conditionalLogic = new ConditionalLogic();
    if (isModalClose) {
      if (navigationcontent) {
        let selectedQuestion = this.findObjectByUniqueID(
          this.configureForm.value.navigateTo
        );
        label = selectedQuestion.Name;
        let sourcQuestion = this.findObjectByUniqueID(this.SourceQuestionId);
        let edgeValue = '';
        if (sourcQuestion) {
          let options = sourcQuestion.Options?.find(
            (item: { UniqueID: any }) =>
              item.UniqueID === this.configureForm.value.selection
          );
          if (options) {
            edgeValue = options.OptionValue;
          }
        }
        this.navigationData.UniqueID = uuid();
        this.navigationData.DestinationQuestionID =
          this.configureForm.value.navigateTo || '';
        this.navigationData.EdgeRefID =
          this.configureForm.value.selection || '';
        this.navigationData.EdgeValue = edgeValue || '';
        this.navigationData.MandatoryDependantQuestion = [];
        this.navigationData.Score = 0;
        this.navigationOptions.push(this.navigationData);
        CreateObjectForDestinationNode.SourceQuestinID =
          this.SourceQuestionId || '';
        CreateObjectForDestinationNode.Name = label;
        CreateObjectForDestinationNode.AllowScoring =
          this.configureForm.value.isAllowScoring || false;
        CreateObjectForDestinationNode.Mandatory =
          this.configureForm.value.mandatory || false;
        CreateObjectForDestinationNode.ConditionsExist =
          this.configureForm.value.conditions || false;
        CreateObjectForDestinationNode = new ConditionalLogic();
        this.navigationData = new NavigationData();

        if (selectedQuestion.Name) {
          this.configureForm.value.Label = selectedQuestion.Name;
        } else {
          this.configureForm.value.Label = selectedQuestion.Label;
        }
        this.isGraphLoaded = false;
        this.addToNodes(
          this.configureForm.value.Label,
          edgeValue,
          this.configureForm.value.selection,
          this.configureForm.value.navigateTo
        );
      }
      let duplicatedata: any = [];
      duplicatedata = this.findConditionalUniqueID(this.SourceQuestionId);
      if (duplicatedata) {
        duplicatedata.Name = label;
        duplicatedata.AllowScoring =
          this.configureForm.value.isAllowScoring || false;
        duplicatedata.Mandatory = this.configureForm.value.mandatory || false;
        if (this.configureForm.value.conditions == undefined) {
          duplicatedata.ConditionsExist =
            duplicatedata.ConditionsExist || false;
        } else {
          duplicatedata.ConditionsExist =
            this.configureForm.value.conditions || false;
        }

        duplicatedata.DisplayOrder =
          this.conditionalLogicData.ConditionalLogic.length;
        duplicatedata.SourceQuestinID = this.SourceQuestionId || '';
        this.navigationOptions.forEach((element: any) => {
          duplicatedata.Conditions.push(element);
        });
        this.navigationOptions = [];
        this.pushItemByUniqueID(duplicatedata, this.SourceQuestionId);
        let ChartJSON = [];
        ChartJSON.push({ Nodes: this.nodes, Links: this.links });
        this.formMultiitionalLogic.ChartJson = JSON.stringify(ChartJSON);
      } else {
        CreateObjectForDestinationNode.SourceQuestinID =
          this.SourceQuestionId || '';
        CreateObjectForDestinationNode.Name = label;
        CreateObjectForDestinationNode.AllowScoring =
          this.configureForm.value.isAllowScoring || false;
        CreateObjectForDestinationNode.Mandatory =
          this.configureForm.value.mandatory || false;
        CreateObjectForDestinationNode.ConditionsExist =
          this.configureForm.value.conditions || false;
        this.navigationOptions.forEach((element: NavigationData) => {
          CreateObjectForDestinationNode.Conditions.push(element);
        });

        this.navigationOptions = [];

        let ChartJSON = [];
        ChartJSON.push({ Nodes: this.nodes, Links: this.links });
        this.formMultiitionalLogic.ChartJson = JSON.stringify(ChartJSON);
        this.conditionalLogicData.ConditionalLogic.push(
          CreateObjectForDestinationNode
        );
        CreateObjectForDestinationNode = new ConditionalLogic();
      }
    }
    if (
      !this.optionsData.length &&
      this.configureForm.controls.conditions.value
    ) {
      this.configureForm.controls.selection.disable();
      this.configureForm.controls.navigateTo.disable();
      if (this.configureForm.controls.mandatory.value) {
        this.configureForm.controls.conditions.disable();
      }
    }
    if (
      this.nodeRelations.length == 1 &&
      !this.configureForm.controls.conditions.value
    ) {
      this.configureForm.controls.navigateTo.disable();
    }

    let index = this.nodeRelations.findIndex(
      (data: any) => data.conditionID == null || undefined
    );
    if (index != -1 && !this.optionsData.length) {
      this.configureForm.controls.navigateTo.disable();
    }
    if (
      this.configureForm.controls.mandatory.value &&
      !this.optionsData.length
    ) {
      this.configureForm.controls.selection.disable();
      this.configureForm.controls.navigateTo.disable();
    }
    console.log("Question single section submit successful");
  }

  msf_createObjectForDestinationNode = new ConditionalLogic();
  msf_label = '';
  onClickOK(isModalClose) {
    let startNode = {
      SourceQuestinID: '1',
      ConditionsExist: false,
      Mandatory: false,
      Name: 'START',
      AllowScoring: false,
      DisplayOrder: 0,
      Conditions: [],
    };
    let navigationcontent = true;

    if (
      !this.findConditionalUniqueID('1') &&
      this.conditionalLogicData?.ConditionalLogic
    ) {
      this.conditionalLogicData.ConditionalLogic.push(startNode);
    }

    if (!this.configureForm.value.navigateTo) {
      navigationcontent = false;
    }

    if (!isModalClose) {
      if (navigationcontent) {
        this.handleCloseWithNavContent();
      }
    } else {
      if (navigationcontent) {
        this.handleCloseWithoutNavContent();
      }

      let duplicatedata = this.findConditionalUniqueID(this.SourceQuestionId);
      if (duplicatedata) {
        this.handleDuplicateData(duplicatedata);
      } else {
        this.handleUniqueData();
      }

      this.modalReference.close();
    }

    this.configureFormControlsMSF();
    console.log("Section submit successful");
  }

  configureFormControlsMSF() {
    if (
      this.nodeRelations.length == 1 &&
      !this.configureForm.controls.conditions.value
    ) {
      this.configureForm.controls.navigateTo.disable();
    }

    let index = this.nodeRelations.findIndex(
      (data: any) => data.conditionID == null || undefined
    );
    if (index != -1 && !this.optionsData.length) {
      this.configureForm.controls.navigateTo.disable();
    }
    if (
      this.configureForm.controls.mandatory.value &&
      !this.optionsData.length
    ) {
      this.configureForm.controls.selection.disable();
      this.configureForm.controls.navigateTo.disable();
    }
  }

  handleCloseWithNavContent() {
    let selectedQuestion = this.findObjectByUniqueID(
      this.configureForm.value.navigateTo
    );

    let sourcQuestion = this.findObjectByUniqueID(this.SourceQuestionId);
    let edgeValue = '';
    if (sourcQuestion && sourcQuestion.Options) {
      let options = sourcQuestion.Options.find(
        (item: { UniqueID: any }) =>
          item.UniqueID === this.configureForm.value.selection
      );

      if (options) {
        edgeValue = options.OptionValue;
      }
    }
    this.navigationData.UniqueID = uuid();
    this.navigationData.DestinationQuestionID =
      this.configureForm.value.navigateTo || '';
    this.navigationData.EdgeRefID = this.configureForm.value.selection || '';
    this.navigationData.EdgeValue = edgeValue || '';
    this.navigationData.MandatoryDependantQuestion = [];
    this.navigationData.Score = 0;
    this.navigationOptions.push(this.navigationData);
    this.msf_createObjectForDestinationNode.SourceQuestinID =
      this.SourceQuestionId;

    this.navigationData = new NavigationData();

    if (selectedQuestion.Name) {
      this.configureForm.value.Label = selectedQuestion.Name;
    } else {
      this.configureForm.value.Label = selectedQuestion.Label;
    }

    this.isGraphLoaded = false;
    this.addToNodes(
      this.configureForm.value.Label,
      edgeValue,
      this.configureForm.value.selection,
      this.configureForm.value.navigateTo
    );
  }

  handleCloseWithoutNavContent() {
    let selectedQuestion = this.findObjectByUniqueID(
      this.configureForm.value.navigateTo
    );

    this.msf_label = selectedQuestion.Name;

    let sourcQuestion = this.findObjectByUniqueID(this.SourceQuestionId);
    let edgeValue = '';
    if (sourcQuestion) {
      let options = sourcQuestion.Options?.find(
        (item: { UniqueID: any }) =>
          item.UniqueID === this.configureForm.value.selection
      );
      if (options) {
        edgeValue = options.OptionValue;
      }
    }
    this.navigationData.UniqueID = uuid();
    this.navigationData.DestinationQuestionID =
      this.configureForm.value.navigateTo || '';
    this.navigationData.EdgeRefID = this.configureForm.value.selection || '';
    this.navigationData.EdgeValue = edgeValue || '';
    this.navigationData.MandatoryDependantQuestion = [];
    this.navigationData.Score = 0;
    this.navigationOptions.push(this.navigationData);
    this.msf_createObjectForDestinationNode.SourceQuestinID =
      this.SourceQuestionId || '';
    this.msf_createObjectForDestinationNode.Name = this.msf_label;
    this.msf_createObjectForDestinationNode.AllowScoring =
      this.configureForm.value.isAllowScoring || false;
    this.msf_createObjectForDestinationNode.Mandatory =
      this.configureForm.value.mandatory || false;
    this.msf_createObjectForDestinationNode.ConditionsExist =
      this.configureForm.value.conditions || false;

    this.msf_createObjectForDestinationNode = new ConditionalLogic();
    this.navigationData = new NavigationData();

    if (selectedQuestion.Name) {
      this.configureForm.value.Label = selectedQuestion.Name;
    } else {
      this.configureForm.value.Label = selectedQuestion.Label;
    }
    this.isGraphLoaded = false;
    this.addToNodes(
      this.configureForm.value.Label,
      edgeValue,
      this.configureForm.value.selection,
      this.configureForm.value.navigateTo
    );
  }

  // COMBO-05
  handleDuplicateData(duplicatedata) {
    duplicatedata.Name = this.msf_label;
    duplicatedata.AllowScoring =
      this.configureForm.value.isAllowScoring || false;
    duplicatedata.Mandatory = this.configureForm.value.mandatory || false;
    if (this.configureForm.value.conditions == undefined) {
      duplicatedata.ConditionsExist = duplicatedata.ConditionsExist || false;
    } else {
      duplicatedata.ConditionsExist =
        this.configureForm.value.conditions || false;
    }

    duplicatedata.DisplayOrder =
      this.conditionalLogicData.ConditionalLogic.length;
    duplicatedata.SourceQuestinID = this.SourceQuestionId || '';

    this.navigationOptions.forEach((element: any) => {
      duplicatedata.Conditions.push(element);
    });
    this.navigationOptions = [];

    this.pushItemByUniqueID(duplicatedata, this.SourceQuestionId);
    let ChartJSON = [];

    ChartJSON.push({ Nodes: this.nodes, Links: this.links });
    if (this.formMultiitionalLogic) {
      this.formMultiitionalLogic['ChartJson'] = JSON.stringify(ChartJSON);
    }
  }

  handleUniqueData() {
    this.msf_createObjectForDestinationNode.SourceQuestinID =
      this.SourceQuestionId || '';
    this.msf_createObjectForDestinationNode.Name = this.msf_label;
    this.msf_createObjectForDestinationNode.AllowScoring =
      this.configureForm.value.isAllowScoring || false;
    this.msf_createObjectForDestinationNode.Mandatory =
      this.configureForm.value.mandatory || false;
    this.msf_createObjectForDestinationNode.ConditionsExist =
      this.configureForm.value.conditions || false;

    this.navigationOptions.forEach((element: NavigationData) => {
      this.msf_createObjectForDestinationNode.Conditions.push(element);
    });

    this.navigationOptions = [];

    let ChartJSON = [];

    ChartJSON.push({ Nodes: this.nodes, Links: this.links });
    if (this.formMultiitionalLogic) {
      this.formMultiitionalLogic.ChartJson = JSON.stringify(ChartJSON);
    }

    if (this.conditionalLogicData?.ConditionalLogic) {
      this.conditionalLogicData.ConditionalLogic.push(
        this.msf_createObjectForDestinationNode
      );
    }
    this.msf_createObjectForDestinationNode = new ConditionalLogic();
  }

  public onFilterChange() {}
  public onDropDownClose() {}

  onScoreEnter(index: any, event: any, nodeRelation: any) {
    let linkIndex = this.links.findIndex(
      (link: any) => link.id === nodeRelation.id
    );
    const nodeLogicIdx = this.conditionalLogicData.ConditionalLogic.findIndex(
      (item) => item.SourceQuestinID === this.SourceQuestionId
    );
    if (linkIndex !== -1) {
      this.links[linkIndex].points = Number(event.target.value);
    }
    if (this.navigationOptions[index] != undefined) {
      this.navigationOptions[index].Score = Number(event.target.value);
    } else {
      if (
        this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[
          index
        ]
      ) {
        if (nodeLogicIdx !== -1) {
          this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[
            index
          ].Score = Number(event.target.value);
        }
      } else {
        this.navigationOptions[
          index -
            this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions
              .length
        ].Score = Number(event.target.value);
      }
    }

    if (
      this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[index]
    ) {
      if (nodeLogicIdx !== -1) {
        this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[
          index
        ].Score = Number(event.target.value);
      }
    }
    this.nodeRelations[index].score = event.target.value;
    this.conditionLogicObjs.forEach((obj: any) => {
      if (obj.SourceQuestinID == this.selectedNode.id) {
        obj.conditions.forEach(
          (cond: { DestinationQuestionID: any; Score: any }) => {
            if (
              this.nodeRelations[index].target == cond.DestinationQuestionID
            ) {
              cond.Score = this.nodeRelations[index].score;
            }
          }
        );
      }
    });
  }

  public onItemSelect(item: any, nodeRelation: Edge, index: any) {

    // update Link
    let linkIndex = this.links.findIndex(
      (link: Edge) =>
        link.id === nodeRelation.id
    );
    if (
      linkIndex !== -1 &&
      !this.links[linkIndex].data.some((e) => e.UniqueID === item.UniqueID)
    ) {
      this.links[linkIndex].data.push(item);
    }

    const nodeLogicIdx = this.conditionalLogicData.ConditionalLogic.findIndex(
      (item) => item.SourceQuestinID === this.SourceQuestionId
    );

    if (
      this.navigationOptions.length &&
      this.navigationOptions[index] != undefined
    ) {
      this.navigationOptions[index].MandatoryDependantQuestion.push(
        item.UniqueID
      );
    } else {
      if (
        this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[
          index
        ]
      ) {
        const duplicateEntry = this.conditionalLogicData.ConditionalLogic[
          nodeLogicIdx
        ].Conditions[index].MandatoryDependantQuestion.includes(item.UniqueID);
        if (nodeLogicIdx !== -1 && !duplicateEntry) {
          this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[
            index
          ].MandatoryDependantQuestion.push(item.UniqueID);
        }
      } else {
        if (this.navigationOptions.length) {
          const duplicateEntry = this.navigationOptions[
            index -
              this.conditionalLogicData.ConditionalLogic[nodeLogicIdx]
                .Conditions.length
          ].MandatoryDependantQuestion.includes(item.UniqueID);
          if (!duplicateEntry) {
            this.navigationOptions[
              index -
                this.conditionalLogicData.ConditionalLogic[nodeLogicIdx]
                  .Conditions.length
            ].MandatoryDependantQuestion.push(item.UniqueID);
          }
        }
      }
    }
    if (
      this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[index]
    ) {
      if (
        nodeLogicIdx !== -1 &&
        !this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[
          index
        ].MandatoryDependantQuestion.includes(item.UniqueID)
      ) {
        this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[
          index
        ].MandatoryDependantQuestion.push(item.UniqueID);
      }
    }
  }

  public onDeSelect(item: any, nodeRelation: Edge, index: any) {
    let linkIndex = this.links.findIndex(
      (link: Edge) =>
        link.id === nodeRelation.id
    );
    if (linkIndex !== -1) {
      let removeindex = this.links[linkIndex].data.findIndex(
        (data: any) => data.UniqueID === item.UniqueID
      );
      this.links[linkIndex].data.splice(removeindex, 1);
    }
    if (this.navigationOptions.length) {
      let removeindex = this.navigationOptions[
        index
      ].MandatoryDependantQuestion.indexOf(item.UniqueID);
      this.navigationOptions[index].MandatoryDependantQuestion.splice(
        removeindex,
        1
      );
    }

    const nodeLogicIdx = this.conditionalLogicData.ConditionalLogic.findIndex(
      (item) => item.SourceQuestinID === this.SourceQuestionId
    );
    if (
      this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[index]
    ) {
      if (nodeLogicIdx !== -1) {
        let removeindex = this.conditionalLogicData.ConditionalLogic[
          nodeLogicIdx
        ].Conditions[index].MandatoryDependantQuestion.indexOf(item.UniqueID);
        this.conditionalLogicData.ConditionalLogic[nodeLogicIdx].Conditions[
          index
        ].MandatoryDependantQuestion.splice(removeindex, 1);
      }
    }
  }

  public onSelectAll(items: any, nodeRelation: any, index: any) {
    items.forEach((item) => {
      this.onItemSelect(item, nodeRelation, index);
    });
  }
  public onDeSelectAll(items: any, nodeRelation: any, index: any) {
    if (!items.length)
      items = this.AllQuestions.map((UniqueID, Name) => ({ UniqueID, Name }));
    items.forEach((item) => {
      this.onDeSelect(item, nodeRelation, index);
    });
  }

  navigationOptions: any = [];

  addToNodes(label: any, selectionCondition: any, edgeValueId: any, qId: any) {
    this.clearSelectedQuestion();
    if (this.selectedNode) {
      let obj: Node = {
        id: qId,
        label: label,
        mandatory: this.configureForm.controls['mandatory'].value?.toString(),
        condition: this.configureForm.controls.conditions.value?.toString(),
        scoring: this.configureForm.controls.isAllowScoring.value?.toString(),
      };
      this.nodes = [...this.nodes, obj];
      this.addToLinks(
        this.selectedNode.id,
        qId,
        selectionCondition,
        edgeValueId
      );
    }
  }

  addToNodesSection(
    label: any,
    selectionCondition: any,
    edgeValueId: any,
    qId: any
  ) {
    this.clearSelectedQuestion();
    let obj: Node = {
      id: qId,
      label: label,
      mandatory: this.configureForm.controls['mandatory'].value?.toString(),
      condition: this.configureForm.controls.conditions.value?.toString(),
      scoring: this.configureForm.controls.isAllowScoring.value?.toString(),
    };
    this.nodes = [...this.nodes, obj];
    this.addToLinks(this.selectedNode[0].id, qId, selectionCondition, '');
  }

  addToLinks(source: any, target: any, linkLabel: any, edgeValueId: any) {
    let obj: Edge = {
      source: source,
      target: target,
      label: linkLabel,
      conditionID: edgeValueId,
      data: [],
    };
    this.links = [...this.links, obj];
    this.updateChart();
    this.assignNodeRelations();
    this.createConditionObj();
    this.onConditionChange();
  }

  SaveConditionalLogic() {
    if (!this.isSection) {
      this.formMultiitionalLogic.SectionConditions = [];
      this.formMultiitionalLogic.TemplateID =
        localStorage.getItem('TemplateId') || '';
      this.conditionalLogicData.SectionUniqueID =
        localStorage.getItem('SectionId') || '';

      this.formMultiitionalLogic.SectionConditions[0] =
        this.conditionalLogicData;
    }

    const swalWithBootstrapButtons = swal.mixin({
      customClass: {
        confirmButton: 'btn',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    });

    this.apiService.SaveConditionalLogic(this.formMultiitionalLogic).subscribe({
      next: (response: any) => {
        if ([response][0].Success) {
          swalWithBootstrapButtons.fire({
            title: 'Success!',
            text: 'Conditional Logic saved successfully',
            icon: 'success',
            confirmButtonText: 'OK',
          });
        } else {
          swalWithBootstrapButtons.fire({
            title: 'Failure!',
            text: [response][0].Msg,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      },
      error: (error: any) => {
        swalWithBootstrapButtons.fire({
          title: 'Failure!',
          text: 'An error occured while saving the data.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      },
    });
  }

  SaveMSFConditionalLogic() {
    this.formMultiitionalLogic.SectionConditions = [];
    this.formMultiitionalLogic.TemplateID =
      localStorage.getItem('TemplateId') || '';

    this.conditionalLogicData.SectionUniqueID =
      localStorage.getItem('SectionId') || '';

    this.formMultiitionalLogic.SectionConditions[0] = this.conditionalLogicData;

    this.curateEdgeRefIdMissingNodes();

    this.apiService.SaveConditionalLogic(this.formMultiitionalLogic).subscribe({
      next: (response: any) => {
        if (response.Success) {
          this.swalWithBootstrapButtons.fire({
            title: 'Success!',
            text: 'Conditional Logic saved successfully',
            icon: 'success',
            confirmButtonText: 'OK',
          });
        } else {
          this.swalWithBootstrapButtons.fire({
            title: 'Failure!',
            text: response.Msg,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      },
      error: (error: any) => {
        this.swalWithBootstrapButtons.fire({
          title: 'Failure!',
          text: 'An error occured while saving the data.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      },
    });
  }

  curateEdgeRefIdMissingNodes() {
    this.conditionalLogicData.ConditionalLogic.forEach(
      (nodeDetailing, nIdx) => {
        if (nodeDetailing?.Conditions?.length) {
          nodeDetailing?.Conditions?.forEach((conditioning, cIdx) => {
            const sourceQuestionId = nodeDetailing?.SourceQuestinID;
            const fieldRequired = this.AllQuestions?.find(
              (field) => field?.UniqueID === sourceQuestionId
            );
            const optionRequired = fieldRequired?.Options?.find(
              (opt) => opt?.OptionValue === conditioning?.EdgeValue
            );
            if (!conditioning?.EdgeRefID) {
              conditioning.EdgeRefID = optionRequired?.UniqueID ?? 'EMPTY';
            }
          });
        }
      }
    );
  }

  swalWithBootstrapButtons = swal.mixin({
    customClass: {
      confirmButton: 'btn',
      cancelButton: 'btn btn-danger',
    },
    buttonsStyling: false,
  });
  deleteEntireLogic() {
    if (confirm('Are you sure want to delete the entire logic?')) {
      this.apiService.GetConditionaDetails().subscribe({
        next: (response: any) => {
          const data = response?.Data;
          const sectionConditions =
            data?.SectionConditions?.map((item) => ({
              ...item,
              ConditionalLogic: [
                {
                  UniqueID: uuid(),
                  EdgeValue: '',
                  EdgeRefID: null,
                  DestinationQuestionID: '',
                  Score: 0,
                  MandatoryDependantQuestion: [''],
                },
              ],
            })) ?? [];
          const idxOfSecWithLogic = sectionConditions?.findIndex(
            (s) => s?.ConditionalLogic?.length
          );
          const secIdxWithLogic =
            idxOfSecWithLogic === -1 ? 0 : idxOfSecWithLogic;
          const templateId = data.TemplateID;
          const startNode = [
            {
              id: '1',
              label: 'START',
              mandatory: '',
              condition: '',
              scoring: '',
            },
          ];
          const conditionalDetailsPayload = {
            ChartJson: JSON.stringify(startNode),
            SectionConditions: [sectionConditions[secIdxWithLogic]],
            TemplateID: templateId,
          };
          this.saveDeletedLogic(conditionalDetailsPayload);
        },
        error: () => {},
      });
    }
  }
  saveDeletedLogic(payload, successMsg = 'Operation successful') {
    this.apiService.SaveConditionalLogic(payload).subscribe({
      next: (response: any) => {
        localStorage.setItem('ConditionalLogicData', JSON.stringify(payload));
        this.ngOnInit();

        if (response.Success) {
          this.swalWithBootstrapButtons.fire({
            title: 'Success!',
            text: successMsg,
            icon: 'success',
            confirmButtonText: 'OK',
          });
        } else {
          this.swalWithBootstrapButtons.fire({
            title: 'Failure!',
            text: response.Msg,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      },
      error: (error: any) => {
        if (window.location.origin.includes('localhost')) {
          localStorage.setItem('ConditionalLogicData', JSON.stringify(payload));
          this.ngOnInit();
        }
        this.swalWithBootstrapButtons.fire({
          title: 'Failure!',
          text: 'An error occured',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      },
    });
  }

  updateChart() {
    this.update$.next(true);
  }

  getNodeLabel(id: any) {
    let node = this.nodes.find((node: any) => node.id == id);

    return node ? node.label : '';
  }

  ConfirmationMsg = '';
  removeLink(linkToRemove: any) {
    this.linkToRemove = linkToRemove;
    let nextNode = [];
    nextNode = this.conditionalLogicData.ConditionalLogic?.filter(
      (item) => item.SourceQuestinID == linkToRemove.target
    );
    if (!nextNode[0]?.Conditions.length) {
      this.ConfirmationMsg = 'Are you sure want to remove.';
    } else {
      this.ConfirmationMsg =
        'The question that you are deleting has a destination node. If this question is deleted, then its destination node becomes orphan.';
    }
    this.modalConfirmReference = this.modalService.open(
      this.confirmationModal,
      {
        size: 'sm',
        scrollable: true,
      }
    );
  }

  removeLinkConfirmation(linkToRemove: any, close: boolean) {
    if (linkToRemove != undefined) {
      this.links = this.links.filter((link: any) => link.id != linkToRemove.id);
      this.nodeRelations = this.nodeRelations.filter(
        (nodeR: any) => nodeR.id != linkToRemove.id
      );

      //remove related nodes which are not having any inputs
      let isAnyInputLinksFound = this.links.some(
        (link: any) => link.target == linkToRemove.target
      );

      if (!isAnyInputLinksFound) {
        this.nodes = this.nodes.filter(
          (node: any) => node.id != linkToRemove.target
        );

        //out from node to be removed
        this.links = this.links.filter(
          (link: any) => link.source != linkToRemove.target
        );
      }
      let removingQuetion = this.removeNavigationQuetion(
        this.SourceQuestionId,
        linkToRemove.target
      );

      this.updateChart();
      this.onConditionChange();
      if (close) {
        this.modalConfirmReference.close();
      }
    }
  }
  addLink() {
    this.modalAddLinkReference = this.modalService.open(this.addLinkModal, {
      size: 'lg',
      scrollable: true,
    });
  }
  addLinkConfirmation() {}

  getOptinsLength() {
    let options = [];
    let foundQuestionData = this.dropdownQuestions.find(
      (question: any) => question.Fields[0].UniqueID == this.selectedNode.id
    );
    if (foundQuestionData) {
      let quesData = foundQuestionData.data.find(
        (data: any) => data.type == 'dropdown'
      );
      if (quesData) {
        options = [...quesData.dropdowndata];
      } else {
        options = [];
      }
    } else {
      options = [];
    }
    return options.length;
  }

  getLinksLength() {
    let linksRelation = this.links.filter(
      (link: any) => link.source == this.selectedNode.id
    );

    return linksRelation.length;
  }

  isEmptyConditionFound() {
    let linksRelation = this.links.filter(
      (link: any) => link.source == this.selectedNode.id
    );
    let isFoundWithoutCondition = linksRelation.some(
      (link: any) => link.label == ''
    );

    return isFoundWithoutCondition ? true : false;
  }

  removeNonConditionQues() {
    this.nodeRelations = [];
    let tempLinks = [];

    if (this.getLinksLength() > this.getOptinsLength() + 1) {
      tempLinks = this.links.filter(
        (link: any) => link.source == this.selectedNode.id
      );

      let tempNodeRelations: Edge[] = [];
      tempLinks.forEach((tl) => {
        if (!Utils.isEmpty(tl.label)) {
          tempNodeRelations.push(tl);
        } else if (tempNodeRelations.length < this.getOptinsLength() + 1) {
          tempNodeRelations.push(tl);
        }
      });

      this.nodeRelations = [...tempNodeRelations];

      this.links = this.links.filter((el) => {
        return tempNodeRelations.some((f) => {
          return el.source == this.selectedNode.id && el.target === f.target;
        });
      });
    } else {
      this.nodeRelations = this.links.filter(
        (link: any) =>
          link.source == this.selectedNode.id && !Utils.isEmpty(link.label)
      );
      this.links = this.links.filter(
        (link: any) =>
          link.source == this.selectedNode.id && !Utils.isEmpty(link.label)
      );
    }
  }

  createConditionObj() {
    let linksRelation = this.links.filter(
      (link: any) => link.source == this.selectedNode.id
    );
    let condArray: any = [];
    linksRelation.forEach((lr: any) => {
      let linkObj = {
        EdgeValue: lr.label,
        DestinationQuestionID: lr.target,
        Score: lr.score,
        MandatoryDependantQuestion: '',
      };
      condArray.push(linkObj);
    });
    let conditionLogic = {
      SourceQuestinID: this.selectedNode.id, //"",
      ConditionsExist: this.configureForm.value.conditions,
      Name: this.selectedNode.label,
      Mandatory: this.configureForm.value.mandatory,
      AllowScoring: this.configureForm.value.isAllowScoring,
      conditions: condArray,
    };

    const itemIndex = this.conditionLogicObjs.findIndex(
      (o: { SourceQuestinID: any }) => o.SourceQuestinID == this.selectedNode.id
    );
    if (itemIndex > -1) {
      this.conditionLogicObjs[itemIndex] = conditionLogic;
    } else {
      this.conditionLogicObjs.push(conditionLogic);
    }
  }

  disableUserInputs() {
    if (
      this.configureForm.controls.mandatory.value &&
      this.configureForm.controls.conditions.value &&
      this.getLinksLength() >= this.getOptinsLength()
    ) {
      this.configureForm.controls.selection.disable();
      this.configureForm.controls.navigateTo.disable();
    } else if (
      this.configureForm.controls.mandatory.value &&
      this.configureForm.controls.conditions.value &&
      this.getLinksLength() == this.getOptinsLength()
    ) {
      this.configureForm.controls.navigateTo.disable();
    } else {
      this.configureForm.controls.selection.enable();
      this.configureForm.controls.navigateTo.enable();
    }
  }

  Rows(): FormArray {
    return this.SectionFlow.get('Rows') as FormArray;
  }

  newRow(): FormGroup {
    return this.formBuilder.group({
      Source: '',
      Name: '',
      Mandatory: { value: false, disabled: true },
      Condition: { value: '', disabled: true },
      CoditionText: '',
      optionValues: [],
      Target: { value: '', disabled: true },
      allowscore: { value: false, disabled: true },
      score: { value: 0, disabled: true },
      MQuestins: [],
      ConditionsExist: false,
    });
  }

  addRow() {
    this.Rows().push(this.newRow());
  }

  scoreChecked(rowIndex: any) {
    if (this.Rows().controls[rowIndex].get('allowscore').value) {
      this.Rows().controls[rowIndex].get('score').enable();
    } else {
      this.Rows().controls[rowIndex].get('score').setValue(0);
      this.Rows().controls[rowIndex].get('score').disable();
    }
    this.SectionFlow.value.Rows.forEach((element, i) => {
      if (rowIndex != i) {
        if (this.SectionFlow.value.Rows[rowIndex].Source == element.Source) {
          this.Rows()
            .controls[i].get('allowscore')
            .setValue(this.SectionFlow.value.Rows[rowIndex].allowscore);
          if (this.SectionFlow.value.Rows[rowIndex].allowscore) {
            this.Rows().controls[i].get('score').enable();
          } else {
            this.Rows().controls[i].get('score').setValue(0);
            this.Rows().controls[i].get('score').disable();
          }
        }
      }
    });
  }

  selectCondition(rowIndex: any) {
    let selectedOption = this.Rows().controls[rowIndex].value.optionValues.find(
      (item) => item.UniqueID === this.Rows().controls[rowIndex].value.Condition
    );
    if (selectedOption != undefined) {
      this.Rows()
        .controls[rowIndex].get('CoditionText')
        .setValue(selectedOption.OptionValue);
      this.Rows().controls[rowIndex].get('ConditionsExist').setValue(true);
    } else {
      this.Rows()
        .controls[rowIndex].get('CoditionText')
        .setValue(selectedOption.OptionValue);
      this.Rows().controls[rowIndex].get('ConditionsExist').setValue(true);
    }
  }

  changeMandatory(rowIndex: any) {
    this.SectionFlow.value.Rows.forEach((element, i) => {
      if (rowIndex != i) {
        if (this.SectionFlow.value.Rows[rowIndex].Source == element.Source) {
          this.Rows()
            .controls[i].get('Mandatory')
            .setValue(this.SectionFlow.value.Rows[rowIndex].Mandatory);
        }
      }
    });
  }

  selectSource(rowIndex: any) {
    this.Rows().controls[rowIndex].get('Mandatory').enable();
    this.Rows().controls[rowIndex].get('allowscore').enable();
    let optionvalues: any;
    if (this.SectionQuestions) {
      optionvalues = this.SectionQuestions.Fields.find(
        (data: any) =>
          data.UniqueID == this.SectionFlow.value.Rows[rowIndex].Source
      );
    }

    this.Rows().controls[rowIndex].get('Name').setValue(optionvalues.Name);
    if (optionvalues.Options.length) {
      this.Rows().controls[rowIndex].get('Condition').enable();
      this.Rows().controls[rowIndex].get('Target').enable();
    } else {
      this.Rows().controls[rowIndex].get('Target').disable();
      this.Rows().controls[rowIndex].get('Condition').disable();
    }

    this.Rows()
      .controls[rowIndex].get('optionValues')
      .setValue(optionvalues.Options);

    this.SectionFlow.value.Rows.forEach((element, i) => {
      if (rowIndex != i) {
        if (this.SectionFlow.value.Rows[rowIndex].Source == element.Source) {
          this.Rows()
            .controls[rowIndex].get('Mandatory')
            .setValue(element.Mandatory);
          this.Rows()
            .controls[rowIndex].get('allowscore')
            .setValue(element.allowscore);
          if (element.allowscore) {
            this.Rows().controls[rowIndex].get('score').enable();
          } else {
            this.Rows().controls[rowIndex].get('score').setValue(0);
            this.Rows().controls[rowIndex].get('score').disable();
          }
        }
      }
    });
  }

  deleteRow(rowIndex) {
    this.Rows().removeAt(rowIndex);
  }

  formMultiitionalLogic = new FormConditionalLogic();
  onSubmit() {
    this.formMultiitionalLogic.TemplateID =
      localStorage.getItem('TemplateId') || '';
    let ChartJSON = [];
    ChartJSON.push({ Nodes: this.nodes, Links: this.links });
    this.formMultiitionalLogic.ChartJson = JSON.stringify(ChartJSON);

    let sectionConditions = new SectionConditions();

    sectionConditions.SectionUniqueID = this.selectedNode.id;
    sectionConditions.ConditionalLogic = [];
    this.SectionFlow.value.Rows.forEach((element, i) => {
      let conditionalLogic = new ConditionalLogic();
      conditionalLogic.SourceQuestinID = element.Source;
      conditionalLogic.Mandatory = element.Mandatory || false;
      conditionalLogic.ConditionsExist = element.ConditionsExist || false;
      conditionalLogic.AllowScoring = element.allowscore || false;
      conditionalLogic.DisplayOrder = 0;
      conditionalLogic.Name = element.Name;
      let conditions = new NavigationData();
      conditions.DestinationQuestionID = element.Target || '';
      conditions.EdgeRefID = element.CoditionText || '';
      conditions.EdgeValue = element.CoditionText || '';
      conditions.UniqueID = uuid();
      conditions.Score = element.score || 0;
      let MDQ = [];
      if (element.MQuestins) {
        element.MQuestins.forEach((e) => {
          MDQ.push(e.UniqueID);
        });
      }
      conditions.MandatoryDependantQuestion = MDQ;
      if (i != 0) {
        let index = sectionConditions.ConditionalLogic.findIndex(
          (e) => e.SourceQuestinID == element.Source
        );
        if (index != -1) {
          sectionConditions.ConditionalLogic[index].Conditions.push(conditions);
        } else {
          conditionalLogic.Conditions.push(conditions);
          sectionConditions.ConditionalLogic.push(conditionalLogic);
        }
      } else {
        conditionalLogic.Conditions.push(conditions);
        sectionConditions.ConditionalLogic.push(conditionalLogic);
      }
      this.modalReference.close();
    });

    let index = this.formMultiitionalLogic.SectionConditions.findIndex(
      (item) => item.SectionUniqueID === this.selectedNode.id
    );
    if (index != -1) {
      this.formMultiitionalLogic.SectionConditions[index] = sectionConditions;
    } else {
      this.formMultiitionalLogic.SectionConditions.push(sectionConditions);
    }
  }

  SectionQuestions: any;
  otherSectionQuestions = [];
  selectSection(e: any) {
    this.selectedNode = e;
    this.SectionFlow = this.formBuilder.group({
      Rows: this.formBuilder.array([]),
    });

    let sectiondata = this.formMultiitionalLogic.SectionConditions.find(
      (item) => item.SectionUniqueID === this.selectedNode.id
    );

    this.SectionQuestions = this.AllQuestions.find(
      (data: any) => data.UniqueID == this.selectedNode.id
    );
    let other_Sections = this.AllQuestions.filter(
      (data: any) => data.UniqueID != this.selectedNode.id
    );

    let other_SectionQuestions = [];
    other_Sections.forEach((element) => {
      other_SectionQuestions.push(element.Fields);
    });

    // The "mandatory dependant questions" picker must include the CURRENT
    // section's own questions as well — otherwise a dependant that lives in the
    // same section (e.g. imported single-section forms, where a Yes/No question
    // reveals sibling questions in that same section) can neither be selected nor
    // shown as selected when loading saved MandatoryDependantQuestion values.
    const currentSectionFields = this.SectionQuestions?.Fields ?? [];
    const combined = [...currentSectionFields, ...[].concat(...other_SectionQuestions)];
    const seen = new Set<string>();
    this.otherSectionQuestions = combined.filter((q: any) => {
      if (!q || seen.has(q.UniqueID)) return false;
      seen.add(q.UniqueID);
      return true;
    });
    if (sectiondata.ConditionalLogic.length) {
      let intextCount = 0;
      sectiondata.ConditionalLogic.forEach((element, i) => {
        element.Conditions.forEach((e, index) => {
          let optionValuedata = this.SectionQuestions.Fields.find(
            (item) => item.UniqueID == element.SourceQuestinID
          );
          this.addRow();
          this.Rows()
            .controls[intextCount].get('Source')
            .setValue(element.SourceQuestinID);
          this.Rows().controls[intextCount].get('Name').setValue(element.Name);
          this.Rows()
            .controls[intextCount].get('Mandatory')
            .setValue(element.Mandatory);
          this.Rows().controls[intextCount].get('Mandatory').enable();
          this.Rows().controls[intextCount].get('allowscore').enable();
          if (e.EdgeValue) {
            this.Rows().controls[intextCount].get('Condition').enable();
            this.Rows()
              .controls[intextCount].get('Condition')
              .setValue(e.EdgeValue);
            this.Rows()
              .controls[intextCount].get('CoditionText')
              .setValue(e.EdgeValue);
          }
          if (optionValuedata) {
            this.Rows()
              .controls[intextCount].get('optionValues')
              .setValue(optionValuedata.Options);
            this.Rows().controls[intextCount].get('Target').enable();
            this.Rows()
              .controls[intextCount].get('Target')
              .setValue(e.DestinationQuestionID);
          }
          if (element.AllowScoring) {
            this.Rows()
              .controls[intextCount].get('allowscore')
              .setValue(element.AllowScoring);
            this.Rows().controls[intextCount].get('score').enable();
            this.Rows().controls[intextCount].get('score').setValue(e.Score);
          }
          if (e.MandatoryDependantQuestion.length) {
            let MQLoad = [];
            e.MandatoryDependantQuestion.forEach((ele) => {
              const match = this.otherSectionQuestions.find(
                (item) => item.UniqueID == ele
              );
              if (match) MQLoad.push(match);
            });
            if (MQLoad.length) {
              this.Rows()
                .controls[intextCount].get('MQuestins')
                .setValue(MQLoad);
            }
          }
          intextCount++;
        });
      });
    } else {
      this.addRow();
    }

    this.modalReference = this.modalService.open(this.sectionDetails, {
      size: 'xl',
      scrollable: true,
    });
  }
  
  onQuesExtract() {
    this.extractedQuestion = localStorage.getItem('AllQuestions');
    this.extractedConditionalLogic = localStorage.getItem('ConditionalLogicData');
    const formName = localStorage.getItem('Title');
    const blob = new Blob([JSON.stringify({
      Questionnaire: JSON.parse(this.extractedQuestion || '{}'),
      ConditionalLogic: JSON.parse(this.extractedConditionalLogic || '{}')
    }, null, 2)], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${formName}.json`;
    a.click();

    window.URL.revokeObjectURL(url);
  }

  onImportJson() {
    this.modalQuestionImportResponse = this.modalService.open(this.JSONImportContent, {
      fullscreen: true,
      scrollable: true,
    });
  }
  
  reloadPage() {
    window.location.reload();
  }
  create_UUID() {
    let dt = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
  onFileImport(evt: Event) {
    this.uploadedFile = Array.from((evt.target as HTMLInputElement).files ?? []);
  }
  async onImportClick() {
    const templateId = localStorage.getItem('TemplateId');
    for (const f of this.uploadedFile) {
      const text = await f.text();
      const data = JSON.parse(text.replace(/^\uFEFF/, ''));

      // Build a map of old IDs → new IDs so we can fix all cross-references
      const idMap: Record<string, string> = {};

      const secDetails = data.Questionnaire[0].Section.map((item: any) => {
        // Remap section UUID
        const oldSectionId = item.UniqueID;
        const newSectionId = this.create_UUID();
        idMap[oldSectionId] = newSectionId;
        item.UniqueID = newSectionId;
        item.TemplateID = templateId;

        item.Fields = (Array.isArray(item.Fields) ? item.Fields : []).map((field: any) => {
          // Remap field UUID
          const oldFieldId = field.UniqueID;
          const newFieldId = this.create_UUID();
          idMap[oldFieldId] = newFieldId;
          field.UniqueID = newFieldId;

          // Remap option UUIDs and update AnswerHtml references
          if (Array.isArray(field.Options)) {
            field.Options = field.Options.map((opt: any) => {
              const oldOptId = opt.UniqueID;
              const newOptId = this.create_UUID();
              idMap[oldOptId] = newOptId;

              // Update AnswerHtml: replace old option UUID with new one
              if (field.AnswerHtml && oldOptId) {
                field.AnswerHtml = field.AnswerHtml.split(oldOptId).join(newOptId);
              }
              return { ...opt, UniqueID: newOptId };
            });
          }

          // Update AnswerHtml: replace old field UUID with new one (for element IDs)
          if (field.AnswerHtml && oldFieldId) {
            field.AnswerHtml = field.AnswerHtml.split(oldFieldId).join(newFieldId);
          }

          // Update QuestionHtml if it contains the old field ID
          if (field.QuestionHtml && oldFieldId) {
            field.QuestionHtml = field.QuestionHtml.split(oldFieldId).join(newFieldId);
          }

          return field;
        });

        // Recursively handle nested sections
        if (item.Sections) {
          this.remapNestedSections(item.Sections, templateId, idMap);
        }

        return item;
      });

      const secDetailsModified = this.manipulateTemplateIds(secDetails);

      // Save sections sequentially — wait for each to complete
      for (const sec of secDetailsModified) {
        await this.saveCurrAsync(sec);
      }

      // Remap all IDs in conditional logic using the idMap
      if (data.ConditionalLogic) {
        const conditionalDetails = {
          ...data.ConditionalLogic,
          TemplateID: templateId,
        };

        // Remap SectionConditions
        if (Array.isArray(conditionalDetails.SectionConditions)) {
          conditionalDetails.SectionConditions = conditionalDetails.SectionConditions.map((sc: any) => ({
            ...sc,
            SectionUniqueID: idMap[sc.SectionUniqueID] || sc.SectionUniqueID,
            ConditionalLogic: Array.isArray(sc.ConditionalLogic)
              ? sc.ConditionalLogic.map((cl: any) => ({
                  ...cl,
                  SourceQuestinID: idMap[cl.SourceQuestinID] || cl.SourceQuestinID,
                  Conditions: Array.isArray(cl.Conditions)
                    ? cl.Conditions.map((cond: any) => ({
                        ...cond,
                        UniqueID: this.create_UUID(),
                        EdgeRefID: idMap[cond.EdgeRefID] || cond.EdgeRefID,
                        DestinationQuestionID: idMap[cond.DestinationQuestionID] || cond.DestinationQuestionID,
                        MandatoryDependantQuestion: Array.isArray(cond.MandatoryDependantQuestion)
                          ? cond.MandatoryDependantQuestion.map((mq: string) => idMap[mq] || mq)
                          : cond.MandatoryDependantQuestion,
                      }))
                    : cl.Conditions,
                }))
              : sc.ConditionalLogic,
          }));
        }

        await this.saveConditionalDetailsAsync(conditionalDetails);

        // Update localStorage so the UI picks it up after reload
        localStorage.setItem('ConditionalLogicData', JSON.stringify(conditionalDetails));
      }

      // Update AllQuestions in localStorage
      localStorage.setItem('AllQuestions', JSON.stringify([{ Section: secDetailsModified }]));
    }

    this.modalQuestionImportResponse.close();
    this.reloadPage();
  }

  /**
   * Recursively remap UUIDs for nested sections/fields and update HTML references.
   */
  private remapNestedSections(sections: any[], templateId: string, idMap: Record<string, string>) {
    for (const sec of sections) {
      const oldSecId = sec.UniqueID;
      const newSecId = this.create_UUID();
      idMap[oldSecId] = newSecId;
      sec.UniqueID = newSecId;
      sec.TemplateID = templateId;

      if (Array.isArray(sec.Fields)) {
        for (const field of sec.Fields) {
          const oldFieldId = field.UniqueID;
          const newFieldId = this.create_UUID();
          idMap[oldFieldId] = newFieldId;
          field.UniqueID = newFieldId;

          if (Array.isArray(field.Options)) {
            field.Options = field.Options.map((opt: any) => {
              const oldOptId = opt.UniqueID;
              const newOptId = this.create_UUID();
              idMap[oldOptId] = newOptId;
              if (field.AnswerHtml && oldOptId) {
                field.AnswerHtml = field.AnswerHtml.split(oldOptId).join(newOptId);
              }
              return { ...opt, UniqueID: newOptId };
            });
          }

          if (field.AnswerHtml && oldFieldId) {
            field.AnswerHtml = field.AnswerHtml.split(oldFieldId).join(newFieldId);
          }
          if (field.QuestionHtml && oldFieldId) {
            field.QuestionHtml = field.QuestionHtml.split(oldFieldId).join(newFieldId);
          }
        }
      }

      if (sec.Sections) {
        this.remapNestedSections(sec.Sections, templateId, idMap);
      }
    }
  }

  saveConditionalDetails(conditionalDetails: any) {
    this.apiService.SaveConditionalLogic(conditionalDetails).subscribe({
      next: () => { },
      error: (err) => {
        // SM-3233: previously this error was swallowed silently, leaving the
        // user with a half-imported form and no indication of what failed.
        this.reportImportSaveFailure('conditional logic', err);
      },
    });
  }

  /**
   * SM-3233 — Import of an unmodified downloaded template fails at the Complete
   * step with: "Http failure during parsing for .../SaveSection" or similar.
   *
   * Root cause: SaveSection / SaveConditionalLogic POST with the implicit
   * responseType:'json'. When the server returns HTML instead of JSON (due to
   * auth redirect, gateway error, or unhandled exception), Angular's HttpClient
   * throws a JSON parse error. The original handlers either swallowed the error
   * or showed a generic message that did not name the failing section.
   *
   * This handler detects the "HTML-response" signature and surfaces an accurate,
   * actionable message per failing item, naming the section so the user can tell
   * which parts of the import did not persist.
   */
  private reportImportSaveFailure(itemLabel: string, err: unknown): void {
    const isHtmlParseError =
      err instanceof HttpErrorResponse &&
      (err.error instanceof SyntaxError ||
        (typeof err.message === 'string' &&
          err.message.includes('Http failure during parsing')));

    const isAuthRedirect =
      err instanceof HttpErrorResponse &&
      typeof err.url === 'string' &&
      /TermsAndCondition/i.test(err.url);

    console.error(`Failed to save '${itemLabel}' during import:`, err);

    let errorText: string;
    if (isAuthRedirect) {
      errorText = `Failed to save '${itemLabel}': your session is not authorized to ` +
        `complete the import. Please re-open the form and try the import ` +
        `again. If the problem persists, contact support (SM-3233).`;
    } else if (isHtmlParseError) {
      errorText = `Failed to save '${itemLabel}': the server returned an unexpected ` +
        `response. This may be a temporary issue or a session timeout. ` +
        `Please refresh the page and try again. If the problem persists, ` +
        `contact support (SM-3233).`;
    } else {
      errorText = `Failed to save '${itemLabel}': an error occurred while saving ` +
        `during import. Please try again.`;
    }

    swal.fire({
      icon: 'error',
      title: 'Import Failed',
      text: errorText,
    });
  }

  private saveConditionalDetailsAsync(conditionalDetails: any): Promise<any> {
    return firstValueFrom(this.apiService.SaveConditionalLogic(conditionalDetails));
  }

  manipulateTemplateIds(sectionData: ISectionInfo[]) {
    sectionData.forEach((sec) => {
      sec.TemplateID = localStorage.getItem('TemplateId');
      if (sec.Sections) this.manipulateTemplateIds(sec.Sections);
    });
    return [...sectionData];
  }

  saveCurr(sec: ISectionInfo) {
    if (!sec.UpdatedBy) {
      sec.UpdatedBy = { UniqueID: localStorage.getItem('UserId') };
    }
    const sectionLabel = sec?.Title ?? 'section';
    this.apiService.SaveSection(sec).subscribe({
      next: () => { },
      error: (err) => {
        // SM-3233: name the failing section and detect the HTML-response signature.
        this.reportImportSaveFailure(sectionLabel, err);
      },
    });
  }

  private saveCurrAsync(sec: ISectionInfo | any): Promise<any> {
    if (!sec.UpdatedBy) {
      sec.UpdatedBy = { UniqueID: localStorage.getItem('UserId') };
    }
    return firstValueFrom(this.apiService.SaveSection(sec));
  }
  deleteUploadedFile() {
    this.uploadedFile = null;
  }
}
